<template>
  <div class="dialog-container">
    <!-- バックドロップ -->
    <transition name="backdrop" appear>
      <div v-show="visible" class="dialog-backdrop"></div>
    </transition>
    <transition name="dialog" appear>
      <div v-if="visible" class="dialog-wrapper">
        <div class="dialog" :class="[isDemand ? 'demand_dialog' : '']">
          <div
            v-if="dialogTitle"
            :class="['dialog-title', { 'fixed-title': fixTitle }]"
          >
            <h2>
              {{ dialogTitle }}
            </h2>
          </div>
          <slot class="{ 'fixed-title': fixHeader }" name="header-area"></slot>

          <div class="dialog_image-container">
            <img
              v-if="imageType === 'alert'"
              src="@/assets/img/dialog/svg/dialog_alert.svg"
              alt=""
            />
            <img
              v-else-if="imageType === 'done'"
              src="@/assets/img/dialog/svg/dialog_done.svg"
              alt=""
            />
            <img
              v-else-if="imageType === 'survey'"
              src="@/assets/img/dialog/svg/dialog_survey.svg"
              alt=""
            />
            <img
              v-else-if="imageType === 'train'"
              src="@/assets/img/dialog/svg/dialog_train.svg"
              alt=""
            />
            <img
              v-else-if="imageType === 'coupon'"
              class="coupon-image"
              src="@/assets/img/dialog/svg/dialog_coupon.svg"
              alt=""
            />
            <PulseLoader v-else-if="imageType === 'loader'" color="#fdc908" />
            <img
              v-else-if="imageType === 'custom'"
              class="custom-image"
              :src="imageUrl"
              alt=""
            />
          </div>

          <slot name="content-area" class="content-area"></slot>

          <div class="button-container">
            <slot name="button-area"></slot>
          </div>
        </div>
        <!-- /.dialog -->
      </div>
    </transition>
  </div>
</template>

<script>
/*
ダイアログコンポーネント
[slot]
  * content-area; 画像下部に表示される
  * button-area; ボタン置き場
[props]
  * imageType: ダイアログの種類(alert, done, survey, train, loader, custom)
  * imageUrl: 画像のURL(imageTypeがcustomの時必要)
  * initialOpen: 初期表示の有無(trueの場合は最初から表示)
  * dialogTitle: ダイアログタイトル（画像上部に表示される）
  * fixTitle: タイトルをダイアログ上部に固定するか(trueの場合固定)
[methods]
  * open(): ダイアログを表示する(親コンポーネントでrefを指定して呼び出す)
  * close(): ダイアログを消去する(親コンポーネントでrefを指定して呼び出す)
[実装例]
<ItemDialog ref="sampleDialog" type="alert" dialogTitle="this is title." :fixTitle="true">
  <template v-slot:content-area>
    {画像下部の内容}
  </template>
  <template v-slot:button-area>
    {ボタン置き場の内容}
  </template>
</ItemDialog>

表示: this.$refs.sampleDialog.open();
非表示: this.$refs.sampleDialog.close();
*/
export default {
  name: "ItemDialog",
  props: {
    imageType: {
      type: String,
      required: false,
      validator(value) {
        return [
          "alert",
          "done",
          "survey",
          "train",
          "loader",
          "custom",
          "coupon",
        ].includes(value);
      },
    },
    imageUrl: {
      type: String,
      required: false,
    },
    initialOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    dialogTitle: {
      type: String,
      required: false,
      default: null,
    },
    fixTitle: {
      type: Boolean,
      requried: false,
      default: true,
    },
    isDemand: {
      type: Boolean,
      requried: false,
      default: false,
    },
  },
  data() {
    return {
      visible: this.initialOpen,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 遷移中のスタイル
.backdrop-enter-active,
.backdrop-leave-active,
.dialog-enter-active,
.dialog-leave-active {
  transition: all 0.3s;
}

// 表示前、非表示完了のスタイル
.backdrop-enter,
.backdrop-leave-to,
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}

// 表示完了、非表示前のスタイル
.backdrop-enter-to,
.backdrop-leave,
.dialog-enter-to,
.dialog-leave {
  opacity: 1;
}

.custom-image {
  width: 80% !important;
  height: 80% !important;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.coupon-image {
  width: 39px !important;
  height: 25px !important;
  margin-bottom: 20px;
}

.demand_dialog {
  top: 22% !important;
}
.content-area {
  margin-top: 20px;
}
</style>
